import {restApi} from '../../../../../../services/rest'

export const useAgentTypeParameters = (agentTypeId: number) =>
  restApi.endpoints.getAgentType.useQuery(
    {
      agentTypeLocator: `id:${agentTypeId}`,
      fields: 'environmentParameters(**),systemParameters(**),configurationParameters(**)',
    },
    {
      selectFromResult: ({data, isLoading}) => ({
        environmentParameters: data?.environmentParameters,
        systemParameters: data?.systemParameters,
        configurationParameters: data?.configurationParameters,
        isLoading,
      }),
    },
  )
